
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
       <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Nom"
              label-for="basicInput"
            >
            <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.name"
                :plaintext="readOnly"
                placeholder="Nom"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Code"
              label-for="basicInput"
            >

             <validation-provider
              #default="{ errors }"
              name="Code"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.code"
                :plaintext="readOnly"
                placeholder="Code"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Type de remise"
              label-for="Type de remise"
            >
             <validation-provider
              #default="{ errors }"
              name="Type de remise"
              rules="required"
            >
              <v-select
                v-model="form.promotion_type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
               
                :state="errors.length > 0 ? false:null"
                :options="promotionTypeChoices"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>

            <b-form-group
              v-if="form.promotion_type.value=='creator'"
              label="Créateur"
              label-for="Créateur"
            >
             <validation-provider
              #default="{ errors }"
              name="Créateur"
              rules="required"
            >
              <v-select
                v-model="form.creator"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
               
                :state="errors.length > 0 ? false:null"
                :options="creatorChoices"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>

            <b-form-group
              v-if="form.creator && form.promotion_type.value=='creator'"
              label="Produit"
              label-for="Produit"
            >
             <validation-provider
              #default="{ errors }"
              name="Produit"
              rules="required"
            >
              <v-select
                v-model="form.glass"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                 multiple
                :state="errors.length > 0 ? false:null"
                :options="productChoices"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
         
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
        
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              :label="form.type=='fixed' ? 'Montant (€)' : 'Montant (%)'"
              label-for="Prix"
            >
            
             <validation-provider
              #default="{ errors }"
              name="Montant"
              rules="required"
            >
              <b-form-input
              required
                id="Prix"
                v-model="form.amount"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Prix"
                :state="errors.length > 0 ? false:null"
              />
               <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
             <span v-if="form.amount && form.amount!=0 && form.promotion_type.value=='creator'" class="simu-legend">
              Prix public estimé avec réduction de {{form.amount.value}}%  = {{amountFinal}}€
              <br />Montant de la promotion = {{ promoAmount }}€
            </span>
            </b-form-group>
          </b-col>

           <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Actif"
              label-for="Actif"
            >
              <b-form-checkbox
                v-model="form.active"
                
                class="custom-control-primary"
              >
                Actif ?
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
            v-if="form.promotion_type.value!='creator'"
          >
          <b-form-group
              label="Produits"
              label-for="Type de verre"
            >
            
              <v-select
                v-model="form.products"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
               
                multiple
                :options="productGlobalChoices"
              />
              
            </b-form-group>
          </b-col>

          <!-- <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Active la livraison gratuite"
              label-for="Actif"
            >
              <b-form-checkbox
                v-model="form.free_shipping"
                
                class="custom-control-primary"
              >
                Active la livraison gratuite
              </b-form-checkbox>
            </b-form-group>
          </b-col> -->

          <!-- <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Date de fin"
              label-for="Date de fin"
            >
              <b-form-datepicker
                id="example-datepicker"
                v-model="form.end_date"
                class="mb-1"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Montant minimum de commande (€)"
              label-for="Prix"
            >
              <b-form-input
                id="Prix"
                v-model="form.minimum_spend"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Montant minimum"
              />
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Montant maximum de commande (€)"
              label-for="Prix"
            >
              <b-form-input
                id="Prix"
                v-model="form.maximum_spend"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Montant maximum"
              />
            </b-form-group>
          </b-col>

           <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Usage individuel seulement (non cumulable)"
              label-for="Actif"
            >
              <b-form-checkbox
                v-model="form.individual_use"
                
                class="custom-control-primary"
              >
                Usage individuel seulement (non cumulable)
              </b-form-checkbox>
            </b-form-group>
          </b-col>

           <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Exclure les produits soldés"
              label-for="Actif"
            >
              <b-form-checkbox
                v-model="form.exclude_sale_items"
                
                class="custom-control-primary"
              >
                Exclure les produits soldés
              </b-form-checkbox>
            </b-form-group>
          </b-col>

         

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Catégories de produits"
              label-for="Type de verre"
            >
            
              <v-select
                v-model="form.product_categories"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
               
                multiple
                :options="productsCategoriesChoices"
              />
              
            </b-form-group>
          </b-col> -->

           <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Limite d'usage (général)"
              label-for="Prix"
            >
              <b-form-input
                id="Prix"
                v-model="form.usage_limit"
                :plaintext="readOnly"
                type="number"
                step="1"
                placeholder="Limite d'usage (général)"
              />
            </b-form-group>
          </b-col>

           <!-- <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Limite par utilisateur"
              label-for="Prix"
            >
              <b-form-input
                id="Prix"
                v-model="form.user_limit"
                :plaintext="readOnly"
                type="number"
                step="1"
                placeholder="Limite par utilisateur"
              />
            </b-form-group>
          </b-col>


           <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Emails autorisés (séparés par une ,)"
              label-for="basicInput"
            >

              <b-form-input
              
                id="basicInput"
                v-model="form.allowed_emails"
                :plaintext="readOnly"
                placeholder="Emails autorisés"
                
              />
             
            </b-form-group>
          </b-col> -->
        </b-row>
      </b-form>
      </validation-observer>

    </b-card>

      <b-button v-if="edition==false"
     @click="createPromotion"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click="editPromotion"
    >
    Enregistrer
    </b-button>

  </div>
</b-overlay>
</template>

<script>
import { BButton,BFormInput, BForm, BRow, BOverlay,BFormDatepicker, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest,Utils,Auth} from '@simb2s/senseye-sdk'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  name: 'PromotionForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BOverlay,
    BRow,
    BCol,
    BFormFile,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormDatepicker
  },
  data() {
      return {
          currentBase64:null,
          file: null,
          promoAmount:0,
          loading:true,
          products:[],
         
          productsCategoriesChoices: [
            {
              title: 'Collection',
              value: 'collection',
            },
            {
              title: 'Collaboration',
              value: 'collaboration',
            }
          ],
          typeChoices: [
            {
              label: 'Remise fixe (en €)',
              value: 'fixed',
            },
            {
              label: 'Pourcentage',
              value: 'percentage',
            }
          ],
          creatorChoices:[],
          productChoices:[],
          productGlobalChoices:[],
          promotionTypeChoices: [
            {
              label: 'Globale',
              value: 'global',
            },
            {
              label: 'Créateur',
              value: 'creator',
            }
          ],
          products_global:null,
          edition:false,
          amountFinal:0,
          form:{
            name:"",
            code:'',
            amount:0,
            creator:null,
            promotion_type:'global',
            active:true,
            type:'percentage',
            free_shipping:false,
            glass:[],
            use_count:0,
            end_date:null,
            minimum_spend:null,
            maximum_spend:null,
            individual_use:true,
            exclude_sale_items:false,
            products:null,
            product_categories:null,
            allowed_emails:null,
            usage_limit:null,
            user_limit:1
          },
      }
  },
  props: ['promotion', 'readOnly'],
  watch: { 
    "form.creator": async function(newVal, oldVal) { // watch it
      
      await this.getProducts()
      },
    "form.product": async function(newVal, oldVal) { // watch it
      
     this.calculatePromoAmount()
      },
      amount: async function(newVal, oldVal) { // watch it
      
     this.calculatePromoAmount()
      },
    promotion: function(newVal, oldVal) { // watch it
      console.log('type de promo 3')
      console.log(this.promotion.products)
      this.form.products=[]
      
      for(let j=0;j<this.promotion.products.length;j++)
      {
        console.log('ok')
        for(let i=0;i<this.productGlobalChoices.length;i++)
        {
          if(this.promotion.products[j].id == this.productGlobalChoices[i].value)
          {
            console.log('on la')
            this.form.products.push(this.productGlobalChoices[i])
          }
        }
      }
        }
      },    
 
  methods:{
    async getProductsGlobal() {
      let products = await APIRequest.list('glasses')
      this.products_global=products[0];
    
      this.productGlobalChoices=Utils.formatSelect(this.products_global,'name','id')
    
    },
    calculatePromoAmount()
    {
      let promoAmount=0
      let amountFinal=0
      if(this.form.product && this.form.amount)
      {
       
        for(let i=0;i<this.products.length;i++)
        {
         
          if(this.products[i].id==this.form.products.value)
          {
         
            let amount_gross= this.products[i].price - this.products[i].production_price
            let amount_comission=(amount_gross/100)*this.products[i].comission

            promoAmount=(amount_comission/100)*this.form.amount.value
            amountFinal=this.products[i].price - promoAmount
          }
        }
      }
      this.amountFinal=amountFinal.toFixed(2)
      
      this.promoAmount=promoAmount.toFixed(2)
    },
    async getProducts() {
      let products = await APIRequest.list_with_request('glasses', '?creator_owner='+this.form.creator.value)
      
      this.products=products[0];
      this.productChoices=Utils.formatSelectNew(this.products,'name','id')

    },
    async createPromotion()
    {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        try {
          
          let datas=this.form
          let products=null

          datas.promotion_type=this.form.promotion_type.value
          if(datas.promotion_type=='creator')
          {
            datas.user={id:this.form.creator.value}
            products=[]
            for (let i=0;i<this.form.glass.length;i++)
            {
              let item={id:this.form.glass[i].value}
              products.push(item)
            }

            datas.products=products
          }
          else
          {
            datas.user=null
            if(this.form.products)
            {
              if(this.form.products.length)
              {
                products=[]
                for (let i=0;i<this.form.products.length;i++)
                {
                  let item={id:this.form.products[i].value}
                  products.push(item)
                }

                datas.products=products
                
              }
              
            }
          }
          delete datas.creator
          delete datas.glass

          await APIRequest.create('promotions',datas)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'La promotion a bien été créée !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'promotions'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
      })
      
    },
    async getCreators(){
      let creators=await Auth.list_users_by_role('ROLE_CREATOR')
      this.creatorChoices=Utils.formatSelectNew(creators,'name','id')
    },
     
   async editPromotion()
    {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        try {
          let datas={...this.form}
          delete datas.id
          let products=null

          datas.promotion_type=this.form.promotion_type.value
          if(datas.promotion_type=='creator')
          {
            //datas.user={id:this.form.creator.value}
            products=[]
            for (let i=0;i<this.form.glass.length;i++)
            {
              let item={id:this.form.glass[i].value}
              products.push(item)
            }

            datas.products=products
          }
          else
          {
            datas.user=null
            if(this.form.products)
            {
              if(this.form.products.length)
              {
                products=[]
                for (let i=0;i<this.form.products.length;i++)
                {
                  let item={id:this.form.products[i].value}
                  products.push(item)
                }

                datas.products=products
                
              }
              
            }
          }
          delete datas.creator
          delete datas.glass

          await APIRequest.update('promotions',this.promotion.id,datas)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'La promotion a bien été modifiée !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'promotions'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
      })
      
    },
    
     
      
  },
  async mounted(){
    await this.getProductsGlobal()
    await this.getCreators()
    if(this.promotion!=null)
    {
      this.form=this.promotion
      this.file=this.promotion.photo
      this.edition=true
     
      let products=[]
      if(!this.promotion.promotion_type)
      {
        this.promotion.promotion_type='global'
      }
      if(this.promotion.promotion_type=='creator')
      {
      
        this.form.creator={label:this.promotion.user.name,value:this.promotion.user.id}
        this.form.promotion_type={label:'Créateur',value:'creator'}
       
        for(let j=0;j<this.promotion.products.length;j++)
        {
          
          for(let i=0;i<this.productGlobalChoices.length;i++)
          {
          
            if(this.promotion.products[j].id == this.productGlobalChoices[i].value)
            {

             
              products.push({value:this.productGlobalChoices[i].value,label:this.productGlobalChoices[i].title})
            }
          }
        }
        this.form.glass=products
      }
      else
      {
        this.form.creator=null
        for(let j=0;j<this.promotion.products.length;j++)
        {
          for(let i=0;i<this.productGlobalChoices.length;i++)
          {
            if(this.promotion.products[j].id == this.productGlobalChoices[i].value)
            {
              
              products.push(this.productGlobalChoices[i])
            }
          }
        }
        this.form.products=products
      }

    }
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.simu-legend
{
  font-size:10px;
}
</style>